export default function Footer() {
  return (
    <footer className="bg-gray-900 py-10 sm:py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="border-t border-gray-800 mb-6 sm:mb-8"></div>
        
        <div className="flex justify-center gap-4 sm:gap-5 mb-6 sm:mb-8">
          <a
            href="https://www.tiktok.com/@esaullorenzo.a"
            target="_blank"
            rel="noopener noreferrer"
            className="w-11 h-11 sm:w-12 sm:h-12 flex items-center justify-center bg-gray-800 border border-gray-700 rounded-full hover:bg-pink-600 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-tiktok-fill text-lg sm:text-xl text-white"></i>
          </a>
          <a
            href="https://www.youtube.com/@ESAULLORENZO"
            target="_blank"
            rel="noopener noreferrer"
            className="w-11 h-11 sm:w-12 sm:h-12 flex items-center justify-center bg-gray-800 border border-gray-700 rounded-full hover:bg-red-600 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-youtube-fill text-lg sm:text-xl text-white"></i>
          </a>
          <a
            href="https://www.instagram.com/esaullorenzo/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-11 h-11 sm:w-12 sm:h-12 flex items-center justify-center bg-gray-800 border border-gray-700 rounded-full hover:bg-gradient-to-br hover:from-pink-500 hover:to-orange-500 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-instagram-fill text-lg sm:text-xl text-white"></i>
          </a>
        </div>

        <p className="text-center text-xs sm:text-sm text-gray-500 mb-2">
          © 2026 Esaúl Lorenzo. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}